// extracted by mini-css-extract-plugin
export var button = "cookie-banner-module--button--a3f10";
export var buttonContainer = "cookie-banner-module--buttonContainer--43e9e";
export var cookieWrapper = "cookie-banner-module--cookieWrapper--1be09";
export var flex = "cookie-banner-module--flex--997d6";
export var subMenu = "cookie-banner-module--subMenu--40ba4";